class GiftDrawerController extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.onCartChanged = this.onCartChanged.bind(this)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.CHANGED,
      this.onCartChanged,
    )
  }

  /**
   * @param {CustomEvent} e
   *
   * @returns {void}
   */
  onCartChanged (e) {
    const drawers = Array.prototype.slice.call(this.children)

    const types = new Set(
      drawers.map(drawer => drawer.id.replace('shopify-section-', '')),
    )

    fetch(`${window.Shopify.routes.root}?sections=${[...types].join(',')}`)
      .then(response => response.json())
      .then(responseJSON => {
        drawers.forEach(element => {
          element.innerHTML =
            responseJSON[element.id.replace('shopify-section-', '')]
        })
      })
      .catch(e => {
        console.error(e)
      })
  }

  checkValidity () {
    super.checkValidity()

    /** @type {HTMLElement[]} */
    const drawers = this.els.drawer?.elements ?? []
    /** @type {Set<string>} */
    const types = new Set(
      drawers.map(drawer =>
        /**
         * @note `getAttribute` is used here rather than the `productType` getter
         * because the 'gift-drawer' element hasn't been initialised at the time
         * of running, so `productType` cannot be accessed
         */
        drawer.getAttribute('product-type'),
      ),
    )

    if (drawers.size !== types.length) {
      this.throwError(
        `All "gift-drawer" elements must have a unique "product-type" attribute`,
      )
    }
  }

  /** @param {string} type */
  open (type) {
    window.drawers.activeDrawerKey = this.drawerKey

    this.els.drawer?.elements.forEach(drawer => {
      const isVisible = drawer.getAttribute('product-type') === type

      drawer.setAttribute('aria-hidden', !isVisible)
    })
  }

  close () {
    window.drawers.activeDrawerKey = ''
  }

  /** @return {string} */
  get drawerKey () {
    return this.closest('site-drawer').getAttribute('key')
  }
}

if (!window.customElements.get('gift-drawer-controller')) {
  window.customElements.define('gift-drawer-controller', GiftDrawerController)
}
